module.exports = __webpack_public_path__ + "img/export.c5021c9a.svg";